import { useIntl } from 'react-intl';
import { Route, Routes } from 'react-router-dom';

import { DocumentTitle, ErrorView, Sidebar } from '_common/components';

import TenantSettingsPage from './pages/TenantSettingsPage/TenantSettingsPage';
import UserSettingsPage from './pages/UserSettingsPage/UserSettingsPage';
import ObjectSettingsPage from './pages/ObjectSettingsPage/ObjectSettingsPage';
import GroupSettingsPage from './pages/GroupSettingsPage/GroupSettingsPage';
import RoleSettingsPage from './pages/RoleSettingsPage/RoleSettingsPage';

import styles from './SettingsContainer.module.scss';
import { navigateToMyFiles } from 'router/navigation';

const SettingsContainer = () => {
  const intl = useIntl();

  return (
    <div className={styles.root}>
      <Sidebar />
      <Routes>
        <Route
          index
          element={
            <DocumentTitle
              title={`doDOC - ${intl.formatMessage({
                id: 'global.settings',
              })}`}
            >
              <TenantSettingsPage />
            </DocumentTitle>
          }
        />
        <Route
          path="user"
          element={
            <DocumentTitle
              title={`doDOC - ${intl.formatMessage({
                id: 'global.userPreferences',
              })}`}
            >
              <UserSettingsPage />
            </DocumentTitle>
          }
        />
        <Route path=":type/:id" element={<ObjectSettingsPage />} />
        <Route path="group/:id" element={<GroupSettingsPage />} />
        <Route path="role/:id" element={<RoleSettingsPage />} />
        <Route
          path="*"
          element={
            <ErrorView
              error={{
                status: 404,
              }}
              onClick={navigateToMyFiles}
            />
          }
        />
      </Routes>
    </div>
  );
};

export default SettingsContainer;
